import * as React from "react";
function SvgIcAuthRole(props) {
  return <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><g stroke="currentColor"><circle cx={6} cy={4} r={2.5} /><path d="M1 11.5a5 5 0 015-5" strokeLinecap="round" /><path d="M13 9l-4 4-2-3" strokeLinecap="round" strokeLinejoin="round" /></g></svg>;
}
export default SvgIcAuthRole;